export default class WasmError extends Error {
  cause?: Error;

  constructor(message?: string, cause?: Error) {
    super(cause ? `${message}: ${cause.message}` : message);
    this.cause = cause;
  }
}
